/**
 * Fee Template Constants for Admin Frontend
 * Must match backend constants
 */

export const RATE_TYPES = {
  PEAK: 'peak',
  OFF_PEAK: 'off-peak',
  MID_PEAK: 'mid-peak',
  SUPER_OFF_PEAK: 'super-off-peak',
  STANDARD: 'standard',
  WEEKEND: 'weekend',
  WEEKDAY: 'weekday',
  OVERNIGHT: 'overnight',
  DAYTIME: 'daytime',
  EVENING: 'evening'
} as const;

export type RateType = typeof RATE_TYPES[keyof typeof RATE_TYPES];

// List of all valid rate types for validation
export const VALID_RATE_TYPES = Object.values(RATE_TYPES);

// Rate type options for select dropdown
export const RATE_TYPE_OPTIONS = [
  { value: RATE_TYPES.STANDARD, label: 'resources.fee-templates.rateTypes.standard' },
  { value: RATE_TYPES.PEAK, label: 'resources.fee-templates.rateTypes.peak' },
  { value: RATE_TYPES.OFF_PEAK, label: 'resources.fee-templates.rateTypes.off-peak' },
  { value: RATE_TYPES.MID_PEAK, label: 'resources.fee-templates.rateTypes.mid-peak' },
  { value: RATE_TYPES.SUPER_OFF_PEAK, label: 'resources.fee-templates.rateTypes.super-off-peak' },
  { value: RATE_TYPES.OVERNIGHT, label: 'resources.fee-templates.rateTypes.overnight' },
  { value: RATE_TYPES.DAYTIME, label: 'resources.fee-templates.rateTypes.daytime' },
  { value: RATE_TYPES.EVENING, label: 'resources.fee-templates.rateTypes.evening' },
  { value: RATE_TYPES.WEEKEND, label: 'resources.fee-templates.rateTypes.weekend' },
  { value: RATE_TYPES.WEEKDAY, label: 'resources.fee-templates.rateTypes.weekday' }
];

// Default rate type
export const DEFAULT_RATE_TYPE = RATE_TYPES.STANDARD;